import React, { useEffect, useState } from 'react';
import './Modal.css'; // Estilos para o Toast

const Toast = ({ message, type, onClose }) => {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(false);
            onClose();
        }, 3000); // Fecha o Toast após 3 segundos

        return () => clearTimeout(timer);
    }, [onClose]);

    if (!visible) return null;

    return (
        <div className={`toast ${type}`}>
            <span>{message}</span>
        </div>
    );
};

export default Toast;